import React from "react";
import { observer } from "mobx-react";
import Plus from "../Icons/Mobile/Plus.svg";
import PlusActive from "../Icons/Mobile/PlusActive.svg";
import Playlist from "../Icons/Mobile/Playlist.svg";
import Settings from "../Icons/Mobile/Settings.svg";
import PlaylistActive from "../Icons/Mobile/PlaylistActive.svg";
import SettingsActive from "../Icons/Mobile/SettingsActive.svg";
import { useState, useEffect } from "react";
import { Redirect } from "react-router";
import { RssFeed as RssFeedIcon } from "@mui/icons-material";

const MobileMenu = observer(
  ({
    mode,
    trackingId,
    mobileMode,
    changeMode,
    updateMobileSettingsActive,
    updateIsFullPlayer,
  }) => {
    const [redirectUrl, setRedirectUrl] = useState("");

    // Add logging to check when component mounts and renders
    useEffect(() => {
      console.log("MobileMenu component mounted");
      console.log("Current mobileMode:", mobileMode);
    }, [mobileMode]);

    const options = [
      {
        text: "Add Article",
        icon: Plus,
        iconActive: PlusActive,
        onClick: () => {
          updateIsFullPlayer(false);
          updateMobileSettingsActive(false);
          changeMode("addArticle");
        },
      },
      {
        text: "Playlist",
        icon: Playlist,
        iconActive: PlaylistActive,
        onClick: () => {
          updateIsFullPlayer(false);
          updateMobileSettingsActive(false);
          changeMode("playlist");
        },
      },
      {
        text: "Feeds",
        icon: <RssFeedIcon style={{ color: "9098d8" }} />,
        iconActive: <RssFeedIcon style={{ color: "white" }} />,
        onClick: () => {
          if (mode === "discover") {
            window.scrollTo(0, 0);
          }
          updateIsFullPlayer(false);
          updateMobileSettingsActive(false);
          changeMode("discover");
        },
      },
      {
        text: "Other",
        icon: Settings,
        iconActive: SettingsActive,
        onClick: () => {
          updateIsFullPlayer(false);
          updateMobileSettingsActive(true);
        },
      },
    ];

    const activeIndex =
      mobileMode === "addArticle"
        ? 0
        : mobileMode === "playlist"
        ? 1
        : mobileMode === "discover"
        ? 2
        : 3;

    if (redirectUrl) {
      return <Redirect to={redirectUrl} />;
    }

    return (
      <div className="menu-buttons">
        {options.map(({ text, icon, iconActive, onClick }, index) => (
          <div
            key={text}
            className={["option", activeIndex === index ? "option-active" : ""]
              .join(" ")
              .trim()}
            onClick={onClick}
          >
            <div className="image-container">
              {typeof icon === 'string' ? (
                <img src={activeIndex === index ? iconActive : icon} />
              ) : (
                activeIndex === index ? iconActive : icon
              )}
            </div>
            <div>{text}</div>
          </div>
        ))}
      </div>
    );
  }
);

export default MobileMenu;
